import {
  fetchAddress,
  addNewAddress,
  editNewAddress,
  deleteAddressApi,
} from "./address.services";
import { getReverseGeoCode } from "../../shared/geocode";
const dAddress = localStorage.getItem(
  `${process.env.VUE_APP_TENANT}:address_popup`,
)
  ? JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_TENANT}:address_popup`),
    )
  : null;
export default {
  namespaced: true,
  state: {
    deliveryAddress: [],
    defaultAddress: dAddress ? dAddress : {},
    addressLoading: false,
    deleteAddressLoading: "",
  },
  getters: {},
  actions: {
    async deleteAddress(context, payload) {
      context.state.deleteAddressLoading = payload;
      let res = await deleteAddressApi(payload);
      let x = context.state.deliveryAddress.filter((el) => el._id != payload);
      context.commit("setDeliveryAddress", x);
      context.state.deleteAddressLoading = "";
      localStorage.removeItem(`${process.env.VUE_APP_TENANT}:address_popup`);
      return res;
    },
    async fetchDeliveryAddress(context) {
      if (context.state.addressLoading) return;
      context.state.addressLoading = true;
      let res = await fetchAddress();
      context.commit("setDeliveryAddress", res.data?.response?.addresses);
      context.state.addressLoading = false;
      return res;
    },

    async adAddress(context, payload) {
      const data = await getReverseGeoCode(
        `${payload.houseNumber},${payload.street2},${payload.street1},${payload.city},${payload.state},${payload.country}`,
      );
      if (data.data.status === "OK") {
        payload.location = {
          coordinates: [
            data.data.results[0].geometry.location.lng,
            data.data.results[0].geometry.location.lat,
          ],
        };
      }

      //   let payloadAddress = payload;
      payload.contacts = [];
      payload.contacts.push({
        value: payload.phoneNumber,
        contactType: "PRIMARY_PHONE",
      });

      payload.contacts.push({
        value: payload.email,
        contactType: "PRIMARY_EMAIL",
      });
      delete payload.email;
      delete payload.phoneNumber;
      const result = await addNewAddress({
        address: payload,
      });
      if (result.status == 200)
        context.commit("setNewAddedAddress", result.data.response.address);
      return result;
    },
    async editAddress(context, payload) {
      const data = await getReverseGeoCode(
        `${payload.houseNumber},${payload.street2},${payload.street1},${payload.city},${payload.state},${payload.country}`,
      );
      if (data.data.status === "OK") {
        payload.location = {
          coordinates: [
            data.data.results[0].geometry.location.lng,
            data.data.results[0].geometry.location.lat,
          ],
        };
      }

      //   let payloadAddress = payload;
      payload.contacts = [];
      payload.contacts.push({
        value: payload.phoneNumber,
        contactType: "PRIMARY_PHONE",
      });

      payload.contacts.push({
        value: payload.email,
        contactType: "PRIMARY_EMAIL",
      });
      let finalPayload = {
        id: payload.id,
      };
      delete payload.email;
      delete payload.phoneNumber;
      delete payload.id;

      finalPayload.data = {
        address: payload,
      };
      const result = await editNewAddress(finalPayload);
      if (result.status == 200) context.dispatch("fetchDeliveryAddress");
      else return result;
    },
  },
  mutations: {
    updateDefaultData(state, payload) {
      sessionStorage.setItem("updatedAddress", JSON.stringify(payload));
      state.defaultAddress = payload;
    },

    setNewAddedAddress(state, payload) {
      state.defaultAddress = payload;
      state.deliveryAddress.push(payload);
    },
    async setDeliveryAddress(state, payload) {
      state.deliveryAddress = payload;
      if (Array.isArray(payload) && payload.length == 0)
        state.defaultAddress = {};

      const defaultAddress = state.deliveryAddress.find((x) => x.isDefault);
      if (defaultAddress) {
        state.defaultAddress = defaultAddress;
        localStorage.setItem(
          `${process.env.VUE_APP_TENANT}:address_popup`,
          JSON.stringify(defaultAddress),
        );
        return;
      }
      state.defaultAddress =
        JSON.parse(sessionStorage.getItem("updatedAddress")) ||
        state.deliveryAddress[0];
    },
  },
};
